<template>
  <div id="app">
    <nav class="navbar" :class="{ 'scrolled': isScrolled }">
      <div class="nav-container">
        <div class="nav-brand">
          <img src="/logo.png" alt="Oasis Logo" class="nav-logo" />
          <span class="brand-name">OASIS FINANCE</span>
        </div>

        <button class="nav-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul class="nav-menu" :class="{ 'active': isMenuOpen }">
          <li><a href="#home" @click="closeMenu">Accueil</a></li>
          <li><a href="#about" @click="closeMenu">À propos</a></li>
          <li><a href="#features" @click="closeMenu">Services</a></li>
          <li><a href="#gallery" @click="closeMenu">Galerie</a></li>
          <li><a href="#contact" @click="closeMenu">Contact</a></li>
        </ul>
      </div>
    </nav>

    <HeroSection id="home" />
    <AboutSection />
    <FeaturesSection />
    <GallerySection />
    <ContactSection />

    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h4>Oasis Microfinance</h4>
          <p>Votre partenaire de confiance pour tous vos besoins financiers.</p>
          <div class="social-links">
            <a href="#" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
            <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
            <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
          </div>
        </div>

        <div class="footer-section">
          <h4>Liens rapides</h4>
          <ul>
            <li><a href="#about">À propos</a></li>
            <li><a href="#features">Nos services</a></li>
            <li><a href="#contact">Nous contacter</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>Contact</h4>
          <p>📍 184 TONGO, NGAOUNDÉRÉ</p>
          <p>📞 +237 6 55 57 41 19</p>
          <p>✉️ contact@oasismicrofinance.com</p>
        </div>

        <div class="footer-section">
          <h4>Horaires</h4>
          <p>Lundi - Vendredi: 8h - 16h</p>
          <p>Samedi: 9h - 13h</p>
          <p>Dimanche: Fermé</p>
        </div>
      </div>

      <div class="footer-bottom">
        © 2019-2024 Oasis Microfinance. Tous droits réservés.
      </div>
    </footer>

    <button
      class="scroll-top"
      :class="{ 'visible': showScrollTop }"
      @click="scrollToTop"
      aria-label="Retour en haut"
    >
      ↑
    </button>
  </div>
</template>

<script>
import HeroSection from './components/HeroSection'
import AboutSection from './components/AboutSection.vue'
import FeaturesSection from './components/FeaturesSection'
import GallerySection from './components/GallerySection'
import ContactSection from './components/ContactSection'

export default {
  name: 'App',
  components: {
    HeroSection,
    AboutSection,
    FeaturesSection,
    GallerySection,
    ContactSection
  },
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false,
      showScrollTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    // Smooth scroll pour les liens
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault()
        const target = document.querySelector(anchor.getAttribute('href'))
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
      this.showScrollTop = window.scrollY > 300
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #f6f9f8;
  overflow-x: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Navigation */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1rem 0;
  transition: all 0.3s ease;
  background: rgba(4, 76, 58, 0.95);
  backdrop-filter: blur(10px);
}

.navbar.scrolled {
  background: rgba(4, 76, 58, 0.98);
  box-shadow: 0 2px 20px rgba(0,0,0,0.1);
  padding: 0.5rem 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-logo {
  height: 40px;
  width: auto;
}

.brand-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  letter-spacing: 1px;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.nav-toggle span {
  width: 25px;
  height: 3px;
  background: white;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
  margin: 0;
}

.nav-menu li a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-menu li a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #1cc48d;
  transition: width 0.3s ease;
}

.nav-menu li a:hover::after {
  width: 80%;
}

.nav-menu li a:hover {
  background: rgba(28, 196, 141, 0.1);
}

/* Footer */
.footer {
  background: #044c3a;
  color: white;
  padding: 3rem 1rem 1rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  padding-bottom: 2rem;
}

.footer-section h4 {
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
  color: #1cc48d;
}

.footer-section p {
  margin-bottom: 0.8rem;
  opacity: 0.9;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
}

.footer-section ul li {
  margin-bottom: 0.8rem;
}

.footer-section ul li a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
  transition: all 0.3s ease;
}

.footer-section ul li a:hover {
  opacity: 1;
  color: #1cc48d;
  padding-left: 5px;
}

.social-links {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.social-links a {
  width: 40px;
  height: 40px;
  background: rgba(28, 196, 141, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-links a:hover {
  background: #1cc48d;
  transform: translateY(-3px);
}

.footer-bottom {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255,255,255,0.1);
  opacity: 0.8;
}

/* Scroll to top button */
.scroll-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: #1cc48d;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  z-index: 999;
}

.scroll-top.visible {
  opacity: 1;
  visibility: visible;
}

.scroll-top:hover {
  background: #17a97a;
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .nav-toggle {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    flex-direction: column;
    background: rgba(4, 76, 58, 0.98);
    backdrop-filter: blur(10px);
    padding: 2rem;
    gap: 0;
    transform: translateX(100%);
    transition: transform 0.3s ease;
  }

  .nav-menu.active {
    transform: translateX(0);
  }

  .nav-menu li {
    margin-bottom: 1.5rem;
  }

  .nav-menu li a {
    display: block;
    padding: 1rem;
    font-size: 1.1rem;
  }

  .brand-name {
    font-size: 1.1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .scroll-top {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
}
</style>